import { useNavigate } from 'react-router-dom';
import { Alert, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { clearHomeAlertMessage } from '../Redux/slices/ui';
import { FormattedMessage } from 'react-intl';

function HomeAlert({ id, variant = 'danger', title, message, link, linkMsg }) {
  const navigator = useNavigate();
  const dispatch = useDispatch();

  const handleGotoLink = () => {
    clearHomeAlert();
    navigator(link);
  };

  const clearHomeAlert = () => {
    dispatch(clearHomeAlertMessage(id));
  };

  return (
    <Alert
      key={id}
      variant={variant}
      onClose={clearHomeAlert}
      dismissible
      className="d-flex justify-content-between">
      <div>
        <Alert.Heading>{<FormattedMessage id={title} />}</Alert.Heading>
        <FormattedMessage id={message} />
      </div>

      <div className="mt-3">
        {link && (
          <Button onClick={handleGotoLink}>
            <FormattedMessage id={linkMsg} />
          </Button>
        )}
      </div>
    </Alert>
  );
}

export default HomeAlert;
